import growth from "@/assets/growth.webp";
import growthSm from "@/assets/growth-720.webp";

const steps = [
  {
    n: "01",
    title: "Reach out — no pressure",
    body: "Send a note or call. We'll set up a short, free conversation by phone or email so you can share what's going on in your own words.",
  },
  {
    n: "02",
    title: "A first session that actually listens",
    body: "We meet — telehealth or in person at the office on East Second Street. I take time to understand who you are before we plan anything.",
  },
  {
    n: "03",
    title: "A path forward, on your terms",
    body: "Together we shape a plan that's honest about what I can help with and where outside resources may serve you better.",
  },
];

export function Approach() {
  return (
    <section id="approach" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-end gap-10 lg:grid-cols-[1fr_1fr]">
          <div className="reveal">
            <p className="text-xs font-medium uppercase tracking-[0.22em] text-sage-deep">
              The approach
            </p>
            <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-balance sm:text-5xl">
              No run‑around. Just a steady, honest conversation.
            </h2>
          </div>
          <p className="reveal max-w-md text-base leading-relaxed text-foreground/75">
            You've probably been passed around before. Here, the first session is for understanding —
            not paperwork, not a sales pitch, not a script.
          </p>
        </div>

        <div className="mt-16 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div className="reveal relative grain overflow-hidden rounded-3xl">
            <img
              src={growth}
              srcSet={`${growthSm} 720w, ${growth} 960w`}
              alt="Two hands holding soil with a small green seedling, symbolizing growth and care"
              width={960}
              height={672}
              sizes="(min-width: 1280px) 547px, (min-width: 1024px) 42vw, calc(100vw - 40px)"
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover"
            />
          </div>
          <ol className="space-y-2">
            {steps.map((s, i) => (
              <li
                key={s.n}
                className="reveal group relative flex gap-6 rounded-2xl p-6 transition-colors hover:bg-card"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="shrink-0">
                  <div className="flex h-14 w-14 items-center justify-center rounded-full border border-sage/50 bg-sage-soft font-display text-lg text-sage-deep">
                    {s.n}
                  </div>
                </div>
                <div>
                  <h3 className="font-display text-2xl font-medium">{s.title}</h3>
                  <p className="mt-2 leading-relaxed text-foreground/75">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
